import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  makeStyles,
  TablePagination,
  TableSortLabel,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  table: {
    marginTop: theme.spacing(3),
    "& thead th": {
      fontWeight: "600",
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
    "& tbody td": {
      fontWeight: "300",
    },
    "& tbody tr:hover": {
      backgroundColor: "#fffbf2",
      cursor: "pointer",
    },
  },
}));

export default function useTable(
  //   records,
  //   headCells,
  //   filterFn,
  setParams,
  params,
  setStart,
  setEnd,
  rowsPerPage
) {
  const classes = useStyles();
  const handleSearch = (event, value, reason, id) => {
    // const array = event.target.id.split("-");
    // const param = array[0];
    // console.log(event.target.id, value, reason, id);
    if (reason === "select-option")
      setParams({
        ...params,
        [id]: value.id,
        offset: 0,
        limit: rowsPerPage,
      });
    if (reason === "clear")
      setParams({
        ...params,
        [id]: undefined,
        offset: 0,
        limit: rowsPerPage,
      });
  };
  const handleSiteCostSiteFilter = (event, value, reason, id) => {
    // const array = event.target.id.split("-");
    // const param = array[0];
    // console.log(event.target.id, value, reason, id);
    if (reason === "select-option")
      setParams({
        ...params,
        [id]: value.id,
        offset: 0,
        limit: rowsPerPage,
      });
    if (reason === "clear")
      setParams({
        ...params,
        [id]: "3a940f76-626c-4012-8a8e-cf06de78868f",
        offset: 0,
        limit: rowsPerPage,
      });
  };
  const handleDateChange = (event) => {
    const date = event.target.value.toISOString();
    const param = event.target.name;
    if (param === "start") setStart(event.target.value);
    if (param === "end") setEnd(event.target.value);
    setParams({
      ...params,
      [param]: date,
      offset: 0,
      limit: rowsPerPage,
    });
  };
  // const pages = [1000];
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(pages[page]);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const TblContainer = (props) => (
    <Table className={classes.table}>{props.children}</Table>
  );

  const TblHead = (props) => {
    const handleSortRequest = (cellId) => {
      const isAsc = orderBy === cellId && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(cellId);
    };

    return (
      <TableHead>
        {/* <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.disableSorting ? (
                headCell.label
              ) : (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={() => {
                    handleSortRequest(headCell.id);
                  }}
                >
                  {headCell.label}
                </TableSortLabel>
              )}
            </TableCell>
          ))}
        </TableRow> */}
      </TableHead>
    );
  };

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  //   const TblPagination = () => (
  //     <TablePagination
  //       component="div"
  //       page={page}
  //       rowsPerPageOptions={pages}
  //       rowsPerPage={rowsPerPage}
  //       count={records.length}
  //       onChangePage={handleChangePage}
  //       onChangeRowsPerPage={handleChangeRowsPerPage}
  //     />
  //   );

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  //   const recordsAfterPagingAndSorting = () => {
  //     return stableSort(
  //       filterFn.fn(records),
  //       getComparator(order, orderBy)
  //     ).slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  //   };

  return {
    TblContainer,
    TblHead,
    // TblPagination,
    // recordsAfterPagingAndSorting,
    handleSearch,
    handleDateChange,
    handleSiteCostSiteFilter,
  };
}
